import React from "react";
import { Link } from "react-router-dom";
import ctaCardBg from "../../assets/img/bg/cta_bluecard_bg.jpg";

export const CtaAreaOne = () => {
  return (
    <section className="cta-area">
      <div className="container">
        <div
          className="cta-inner-wrap"
          style={{ backgroundImage: `url(${ctaCardBg})` }}
        >
          <div className="row align-items-center">
            <div className="col-lg-9">
              <div className="cta-content">
                <div className="cta-info-wrap">
                  <div className="icon">
                    <i className="flaticon-phone-call"></i>
                  </div>
                  <div className="content">
                    <span>Not Sure Where Your Books Stand?</span>
                    <a href="tel:0123456789">604-XXX-XXXX</a>
                  </div>
                </div>
                <h2 className="title">
                Book Your Free 20-Minute Books Health Check
                </h2>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cta-btn text-end">
                <Link to="/contact" className="btn">
                  Book Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
